import {
  DeploymentUnitOutlined,
  FundOutlined,
  TeamOutlined
} from '@ant-design/icons'

import { EaAuctionIcon } from '@eastcoal/icon/EaAuctionIcon'
import { RouteItem } from '@eastcoal/router/types/route'

import { ConsoleLayout } from '../layouts/ConsoleLayout'
import { UserLayout } from '../layouts/UserLayout'
import { applyRoute } from '../pages/Apply/route'
import { enterpriseAuditRoute } from '../pages/Audit/AuditEnterprise/route'
import { auditListRoute } from '../pages/Audit/AuditList/route'
import { personAuditRoute } from '../pages/Audit/AuditPerson/route'
import { saleAnalysisRoute } from '../pages/Data/SaleAnalysis/route'
import { tradeLogRoute } from '../pages/Data/TradeLog/route'
import { debuggerRoute } from '../pages/Debugger/route'
import { depositRoute } from '../pages/Deposit/router'
import { fundRoute } from '../pages/Finance/Fund/route'
import { homeRoute } from '../pages/Home/route'
import { listingRoute } from '../pages/Listing/route'
import { waybillRoute } from '../pages/Logistics/Waybill/route'
import { messageRoute } from '../pages/Message/route'
import { orderRoute } from '../pages/Order/route'
import { organizationRoute } from '../pages/Team/Organization/route'
import { roleRoute } from '../pages/Team/Role/route'
import { houseAuctionCreateRoute } from '../pages/TradeSession/Auction/House/Create/route'
import { houseAuctionPurchaseListRoute } from '../pages/TradeSession/Auction/House/PurchaseList/route'
import { houseAuctionSaleListRoute } from '../pages/TradeSession/Auction/House/SaleList/route'
import { inquiryAuctionCreateRoute } from '../pages/TradeSession/Auction/Inquiry/Create/route'
import { inquiryAuctionPurchaseListRoute } from '../pages/TradeSession/Auction/Inquiry/PurchaseList/route'
import { inquiryAuctionSaleListRoute } from '../pages/TradeSession/Auction/Inquiry/SaleList/route'
import { rankingAuctionCreateRoute } from '../pages/TradeSession/Auction/Ranking/Create/route'
import { rankingAuctionPurchaseListRoute } from '../pages/TradeSession/Auction/Ranking/PurchaseList/route'
import { rankingAuctionSaleListRoute } from '../pages/TradeSession/Auction/Ranking/SaleList/route'
import { secretAuctionCreateRoute } from '../pages/TradeSession/Auction/Secret/Create/route'
import { secretAuctionPurchaseListRoute } from '../pages/TradeSession/Auction/Secret/PurchaseList/route'
import { secretAuctionSaleListRoute } from '../pages/TradeSession/Auction/Secret/SaleList/route'
import { tenderAuctionCreateRoute } from '../pages/TradeSession/Auction/Tender/Create/route'
import { tenderAuctionPurchaseListRoute } from '../pages/TradeSession/Auction/Tender/PurchaseList/route'
import { tenderAuctionSaleListRoute } from '../pages/TradeSession/Auction/Tender/SaleList/route'
import { traditionAuctionCreateRoute } from '../pages/TradeSession/Auction/Tradition/Create/route'
import { traditionAuctionPurchaseListRoute } from '../pages/TradeSession/Auction/Tradition/PurchaseList/route'
import { traditionAuctionSaleListRoute } from '../pages/TradeSession/Auction/Tradition/SaleList/route'
import { priceCompareCreateRoute } from '../pages/TradeSession/PriceCompare/Create/route'
import { priceComparePurchaseListRoute } from '../pages/TradeSession/PriceCompare/List/Purchase/route'
import { priceCompareSaleListRoute } from '../pages/TradeSession/PriceCompare/List/Sale/route'
import { tradeSessionPublishRoute } from '../pages/TradeSession/Publish/route'
import { userCenterRoute } from '../pages/User/Center/route'
import { loginRoute } from '../pages/User/Login/route'
import { passwordRoute } from '../pages/User/Password/route'
import { registerRotue } from '../pages/User/Register/route'

/**
 * 1. 布局配置
 * 2. 菜单层级配置
 */
export const routes: RouteItem[] = [
  {
    element: <UserLayout />,
    children: [loginRoute, registerRotue, passwordRoute]
  },
  {
    element: <ConsoleLayout />,
    children: [
      debuggerRoute,
      homeRoute,
      userCenterRoute,
      messageRoute,
      {
        title: '认证管理',
        children: [auditListRoute, personAuditRoute, enterpriseAuditRoute]
      },
      {
        title: '团队管理',
        icon: <TeamOutlined />,
        children: [organizationRoute, roleRoute]
      },
      listingRoute,
      depositRoute,
      orderRoute,
      fundRoute,
      applyRoute,
      {
        title: '竞价管理',
        icon: <EaAuctionIcon />,
        children: [
          tradeSessionPublishRoute,
          priceCompareCreateRoute,
          traditionAuctionCreateRoute,
          rankingAuctionCreateRoute,
          houseAuctionCreateRoute,
          secretAuctionCreateRoute,
          inquiryAuctionCreateRoute,
          tenderAuctionCreateRoute,
          {
            title: '我采购的',
            children: [
              traditionAuctionPurchaseListRoute,
              rankingAuctionPurchaseListRoute,
              houseAuctionPurchaseListRoute,
              inquiryAuctionPurchaseListRoute,
              secretAuctionPurchaseListRoute,
              tenderAuctionPurchaseListRoute,
              priceComparePurchaseListRoute
            ]
          },
          {
            title: '我销售的',
            children: [
              traditionAuctionSaleListRoute,
              rankingAuctionSaleListRoute,
              houseAuctionSaleListRoute,
              inquiryAuctionSaleListRoute,
              secretAuctionSaleListRoute,
              tenderAuctionSaleListRoute,
              priceCompareSaleListRoute
            ]
          }
        ]
      },
      {
        title: '数据统计',
        icon: <FundOutlined />,
        children: [tradeLogRoute, saleAnalysisRoute]
      },
      {
        title: '物流管理',
        icon: <DeploymentUnitOutlined />,
        children: [waybillRoute]
      }
    ]
  }
]
